import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiModel } from 'models';
import { Draft, DraftOverviewSearch, Prepack, Product } from './order-draft.types';
import { AvailableLanguage } from 'helpers';

@Injectable()
export class OrderDraftService {
    private readonly itemsPerPage = 10;

    constructor(private apiModel: ApiModel) {}

    public getManufacturerOrderDrafts({
        email,
        pagination
    }: {
        email: string;
        pagination: {
            afterId: string;
            itemsPerPage?: number;
        };
    }): Observable<DraftOverviewSearch> {
        const itemsPerPage = pagination.itemsPerPage ? pagination.itemsPerPage : this.itemsPerPage;
        const afterIdQueryStr = pagination.afterId ? `&afterId=${pagination.afterId}` : '';
        const urlGetAll = `${this.apiModel.getPreorderDraftEndpoint()}?email=${encodeURIComponent(
            email
        )}&limit=${itemsPerPage}${afterIdQueryStr}`;

        return this.apiModel
            .makeHttpObservableRequest({ method: 'GET', url: urlGetAll })
            .pipe(map(({ nextId, drafts = [], total: totalDrafts = 0 }) => ({ drafts, nextId, totalDrafts })));
    }

    public getDraft(draftId: string, language: AvailableLanguage): Observable<Draft> {
        const url = `${this.apiModel.getPreorderDraftEndpoint()}/${draftId}?language=${language}`;
        return this.apiModel.makeHttpObservableRequest({ method: 'GET', url });
    }
}

export type DraftItem = Prepack | Product;
